export default __webpack_public_path__ + "static/media/kitchen4-afterE-1440w.b7a0b852.png";